export enum InputType {
  Input,
  Integer,
  Float,
  Select,
  Bool
}
